/* eslint-disable class-methods-use-this */
import { EntityDto, PagedResultDto } from '@services';
import http from '../httpService';
import {
  CreateInvoice,
  CreateInvoiceCreditDto,
  CreateQuickPayInvoice,
  Invoice,
  InvoiceCredit,
  InvoicePayment,
  PagedInvoiceRequest,
  TransactionType,
  UpdateInvoice,
} from './dto/invoice';

class InvoiceService {
  public async getAll(
    pagedFilterAndSortedRequest: PagedInvoiceRequest
  ): Promise<PagedResultDto<Invoice>> {
    const result = await http.get('api/services/app/Invoice/GetAll', {
      params: pagedFilterAndSortedRequest,
    });
    return result.data.result;
  }

  public async get(entityDto: EntityDto<string>): Promise<Invoice> {
    const result = await http.get('api/services/app/Invoice/Get', { params: entityDto });
    return result.data.result;
  }

  public async getPublicInvoice(entityDto: EntityDto<string>): Promise<Invoice> {
    const result = await http.get('api/services/app/Invoice/GetPublic', { params: entityDto });
    return result.data.result;
  }

  public async getByOrderId(entityDto: EntityDto<string>) {
    const result = await http.get('api/services/app/Invoice/GetByOrderId', {
      params: entityDto,
    });
    return result.data.result;
  }

  public async create(invoice: CreateInvoice) {
    const result = await http.post('api/services/app/Invoice/Create', invoice);
    return result.data.result;
  }

  public async createQuickPay(input: CreateQuickPayInvoice): Promise<Invoice> {
    const result = await http.post('api/services/app/Invoice/CreateQuickPay', input);
    return result.data.result;
  }

  public async update(invoice: UpdateInvoice) {
    const result = await http.put('api/services/app/Invoice/Update', invoice);
    return result.data.result;
  }

  public async createPayment(invoicePayment: InvoicePayment) {
    const result = await http.post('api/services/app/InvoicePayment/Create', invoicePayment);
    return result.data.result;
  }

  public async logBulkPayment(input: {
    invoiceIds: string[];
    method: string;
    transactionType: TransactionType;
    note?: string;
  }): Promise<number> {
    const result = await http.post('api/services/app/Invoice/LogBulkPayment', input);
    return result.data.result;
  }

  public async getCredits(entityDto: EntityDto<string>): Promise<InvoiceCredit[]> {
    try {
     const result = await http.get('api/services/app/Invoice/GetInvoiceCredits', {
      params: entityDto,
    });
    return result.data.result;
    } catch (error) {
      console.error('InvoiceService get credits failed:', error);
      throw error;
    }
  }

  public async addCredit(creditData: CreateInvoiceCreditDto): Promise<Invoice> {
    const result = await http.post('api/services/app/Invoice/AddCredit', creditData);
    return result.data.result;
  }
}

export default new InvoiceService();
